import { getExportJobStatus, downloadExport } from "@/data-access/exports";

const POLL_INTERVAL_MS = 5000;
const MAX_POLL_ATTEMPTS = 60;

type PollCallbacks = {
  onProgress: (progress: { completed: number; total: number }) => void;
  onCompleted: (exportHistoryId: number) => void;
  onFailed: (errorMessage: string) => void;
  onTimeout: () => void;
  isCancelled: () => boolean;
};

export const pollExportJob = async (jobId: number, callbacks: PollCallbacks): Promise<void> => {
  let attempt = 0;

  while (attempt < MAX_POLL_ATTEMPTS) {
    if (callbacks.isCancelled()) return;

    try {
      const status = await getExportJobStatus(jobId);
      if (callbacks.isCancelled()) return;

      callbacks.onProgress(status.progress);

      if (status.status === "completed" && status.exportHistoryId) {
        await downloadExport(status.exportHistoryId);
        callbacks.onCompleted(status.exportHistoryId);
        return;
      }

      if (status.status === "failed") {
        callbacks.onFailed(status.errorMessage || "Export failed, please try again.");
        return;
      }
    } catch {
      if (callbacks.isCancelled()) return;
    }

    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
    attempt++;
  }

  if (!callbacks.isCancelled()) {
    callbacks.onTimeout();
  }
};
